import React, { useState, useEffect } from 'react';
import { questionAPI } from '../../services/api';

export default function History({ projectId }) {
  const [history, setHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchHistory = async () => {
    try {
      const res = await questionAPI.getHistory(projectId);
      setHistory(res.data.questions || res.questions);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const filteredHistory = history.filter(q =>
    q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    q.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="text-center py-10">
        <div className="text-4xl animate-spin">⚡</div>
        <p className="text-gray-600 mt-4">Loading history...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Q&A History</h2>
        <span className="px-4 py-2 rounded-full bg-purple-100 text-purple-700 font-semibold">
          {history.length} conversations
        </span>
      </div>

      {history.length > 0 && (
        <input
          type="text"
          placeholder="🔍 Search history..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 focus:border-purple-500 focus:outline-none"
        />
      )}

      {filteredHistory.length === 0 ? (
        <div className="text-center py-20 space-y-4">
          <div className="text-6xl">📭</div>
          <p className="text-xl text-gray-600">
            {searchTerm ? 'No matching conversations' : 'No Q&A history yet.'}
          </p>
          <p className="text-gray-500">Start asking questions to build your history!</p>
        </div>
      ) : (
        <div className="space-y-4">
          {filteredHistory.map((q, index) => (
            <div
              key={q.id}
              className="p-6 rounded-xl border-2 border-gray-200 hover:border-purple-300 bg-white shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-3 mb-3">
                <span className="text-2xl">❓</span>
                <div className="flex-1">
                  <div className="font-semibold text-lg text-gray-800">{q.question}</div>
                  <div className="text-xs text-gray-500 mt-1">
                    {new Date(q.created_at).toLocaleString()}
                  </div>
                </div>
                <span className="px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-semibold">
                  #{filteredHistory.length - index}
                </span>
              </div>
              
              <div className="flex items-start gap-3 mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <span className="text-2xl">🤖</span>
                <div className="flex-1 text-gray-700 whitespace-pre-wrap">{q.answer}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}